// src/store/slices/sessionSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  timeOfDay: "",
  dartsUsed: "",
  isDrunk: false,
  location: "",
  feeling: "",
  beerAmount: 0, // <-- New field for beer consumption
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setTimeOfDay: (state, action) => {
      state.timeOfDay = action.payload;
    },
    setDartsUsed: (state, action) => {
      state.dartsUsed = action.payload;
    },
    setIsDrunk: (state, action) => {
      state.isDrunk = action.payload;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setFeeling: (state, action) => {
      state.feeling = action.payload;
    },
    setBeerAmount: (state, action) => {
      state.beerAmount = action.payload;
    },
    resetSession: (state) => {
      state.timeOfDay = "";
      state.dartsUsed = "";
      state.isDrunk = false;
      state.location = "";
      state.feeling = "";
      state.beerAmount = 0;
    },
  },
});

export const {
  setTimeOfDay,
  setDartsUsed,
  setIsDrunk,
  setLocation,
  setFeeling,
  setBeerAmount,
  resetSession,
} = sessionSlice.actions;

export default sessionSlice.reducer;
